export const CLEARORGANISATION = 'CLEARORGANISATION';
export const SETSHORTCODE = 'SETSHORTCODE';
export const SET_ONBOARDING_CHECKLIST_SHOWN = 'SET_ONBOARDING_CHECKLIST_SHOWN';
